document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('slider-component.slider-component-desktop').forEach(function (slider) {
    var buttons = slider.querySelector('.slider-buttons');
    var slides = slider.querySelectorAll('.slider__slide');
    if (!buttons || slides.length < 2 || slider.querySelector('.mundobaby-dots')) return;

    var dots = document.createElement('div');
    dots.className = 'mundobaby-dots';
    slides.forEach(function (slide, index) {
      var dot = document.createElement('button');
      dot.type = 'button';
      dot.className = 'mundobaby-dot' + (index === 0 ? ' is-active' : '');
      dot.setAttribute('aria-label', 'Ir para o slide ' + (index + 1));
      dot.addEventListener('click', function () {
        slide.scrollIntoView({ behavior: 'smooth', inline: 'start', block: 'nearest' });
        dots.querySelectorAll('.mundobaby-dot').forEach(function (el, i) {
          el.classList.toggle('is-active', i === index);
        });
      });
      dots.appendChild(dot);
    });
    buttons.appendChild(dots);
  });
});
